/* =====================================================================
   PyaraHome theme — storefront behaviour
   ===================================================================== */
(function () {
  'use strict';
  const T = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || T.moneyFormat || '${{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const fmtNum = (n, dec, th = ',', d = '.') => {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(dec);
      const parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (parts[1] ? d + parts[1] : '');
    };
    const m = fmt.match(re); if (!m) return fmt;
    let v;
    switch (m[1]) {
      case 'amount': v = fmtNum(cents, 2); break;
      case 'amount_no_decimals': v = fmtNum(cents, 0); break;
      case 'amount_with_comma_separator': v = fmtNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmtNum(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmtNum(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmtNum(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': v = fmtNum(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = fmtNum(cents, 2, ' ', '.'); break;
      default: v = fmtNum(cents, 2);
    }
    return fmt.replace(re, v);
  }
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- toast ---------- */
  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('show'), 2400);
  }

  /* ---------- modals ---------- */
  function openModal(el) { if (!el) return; el.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeModals() {
    $$('.modal.open').forEach(m => { m.classList.remove('open'); m.querySelectorAll('video').forEach(v => v.pause()); });
    const vb = $('#videoModalBody'); if (vb) vb.innerHTML = '';
    document.body.style.overflow = '';
  }
  $$('.modal').forEach(m => m.addEventListener('click', e => { if (e.target === m) closeModals(); }));

  /* ---------- drawer & overlay ---------- */
  const overlay = $('#overlay');
  function openDrawer() { $('#menuDrawer')?.classList.add('open'); overlay?.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() {
    $('#menuDrawer')?.classList.remove('open'); overlay?.classList.remove('open'); document.body.style.overflow = '';
    $$('.menu-drawer__panel.sub').forEach(p => p.classList.remove('open'));
    $('[data-panel-main]')?.classList.remove('shift');
    $('[data-facets]')?.classList.remove('open');
  }
  overlay?.addEventListener('click', closeDrawer);

  /* ---------- cart notification ---------- */
  let notifTimer;
  const notif = $('#cartNotification');
  function hideNotification() { notif?.classList.remove('active'); }
  function showNotification(item) {
    if (!notif) return;
    const img = item.image ? `<img src="${item.image}${item.image.includes('?') ? '&' : '?'}width=160" alt="${esc(item.product_title)}" loading="lazy">` : '';
    const opts = item.product_has_only_default_variant ? '' : `<dd>${esc(item.variant_title || '')}</dd>`;
    $('[data-notification-product]', notif).innerHTML =
      `<div class="cart-notification-product"><div class="media small ratio-sq">${img}</div><div><h3>${esc(item.product_title)}</h3><dl>${opts}<dd>Quantity: ${item.quantity}</dd><dd>${formatMoney(item.final_price)}</dd></dl></div></div>`;
    notif.classList.add('active');
    const hw = $('#headerWrapper'); if (hw && hw.getBoundingClientRect().top < 0) hw.scrollIntoView({ block: 'nearest' });
    clearTimeout(notifTimer); notifTimer = setTimeout(hideNotification, 7000);
  }
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(b => { b.textContent = count; b.hidden = !count; });
    $$('[data-cart-count-text]').forEach(b => b.textContent = count);
  }
  async function refreshCart() {
    try {
      const cart = await (await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json();
      updateCartCount(cart.item_count);
      const sec = $('[data-product-section]');
      if (sec) {
        const pid = +sec.dataset.productId;
        const n = cart.items.filter(i => i.product_id === pid).reduce((a, i) => a + i.quantity, 0);
        $$('[data-in-cart]', sec).forEach(e => e.textContent = `(${n} in cart)`);
      }
      return cart;
    } catch (e) { return null; }
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('.js-product-form');
    if (!form || T.cartType === 'page') return;
    e.preventDefault();
    const submitters = $$(`[form="${form.id}"][name="add"]`).concat($$('[name="add"]', form));
    const errEl = $('[data-form-error]', form);
    if (errEl) errEl.hidden = true;
    submitters.forEach(b => { b.setAttribute('aria-disabled', 'true'); b.classList.add('loading'); });
    const fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    try {
      const res = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) {
        const msg = data.description || data.message || 'Could not add to cart';
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; } else toast(msg);
        return;
      }
      closeModals();
      const btn = $('.quick-add [name="add"]', form);
      if (btn) { const t = btn.textContent; btn.classList.add('added'); btn.textContent = 'Added'; setTimeout(() => { btn.classList.remove('added'); btn.textContent = t; }, 1500); }
      showNotification(data);
      refreshCart();
    } catch (err) {
      form.submit();
    } finally {
      submitters.forEach(b => { b.removeAttribute('aria-disabled'); b.classList.remove('loading'); });
    }
  });

  /* ---------- global clicks ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('button,a'); if (!t) return;
    const d = t.dataset;
    if ('drawerOpen' in d) openDrawer();
    else if ('closeDrawer' in d) closeDrawer();
    else if ('closeModal' in d) closeModals();
    else if ('closeNotification' in d) hideNotification();
    else if (d.panel) { $('#' + d.panel)?.classList.add('open'); $('[data-panel-main]')?.classList.add('shift'); }
    else if ('back' in d) { t.closest('.menu-drawer__panel')?.classList.remove('open'); $('[data-panel-main]')?.classList.remove('shift'); }
    else if ('openFacets' in d) { $('[data-facets]')?.classList.add('open'); overlay?.classList.add('open'); }
    else if ('searchOpen' in d) openSearch();
    else if ('searchClose' in d) closeSearch();
    else if ('waJoin' in d) { setTimeout(closeModals, 300); }
    else if (d.qtyStep) {
      const wrap = t.closest('[data-quantity]'); const input = wrap && $('input', wrap); if (!input) return;
      const min = input.hasAttribute('min') ? +input.min : 1;
      input.value = Math.max(min, Math.min(99, (parseInt(input.value) || 0) + (+d.qtyStep)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeModals(); closeDrawer(); hideNotification(); closeSearch(); } });
  document.addEventListener('click', e => {
    if (notif?.classList.contains('active') && !e.target.closest('#cartNotification') && !e.target.closest('[name="add"]')) hideNotification();
  });

  /* ---------- header ---------- */
  addEventListener('scroll', () => $('#headerWrapper')?.classList.toggle('shadow', scrollY > 40), { passive: true });
  function initDesktopMenu() {
    const dets = $$('[data-desktop-menu] details');
    dets.forEach(d => {
      d.addEventListener('toggle', () => { if (d.open) dets.forEach(o => o !== d && (o.open = false)); });
      d.parentNode.addEventListener('mouseleave', () => d.open = false);
      d.querySelector('summary').addEventListener('mouseenter', () => { if (matchMedia('(hover:hover)').matches) d.open = true; });
    });
    document.addEventListener('click', e => { if (!e.target.closest('[data-desktop-menu]')) dets.forEach(d => d.open = false); });
  }

  /* ---------- announcement ---------- */
  function initAnnouncements() {
    $$('[data-announcements]').forEach(w => {
      const track = $('.announcement-track', w); if (!track) return;
      const n = track.children.length; if (n < 2) return;
      let i = 0; const go = k => { i = (k + n) % n; track.style.transform = `translateX(-${i * 100}%)`; };
      $('[data-ann-prev]', w)?.addEventListener('click', () => go(i - 1));
      $('[data-ann-next]', w)?.addEventListener('click', () => go(i + 1));
      if (!reduceMotion) setInterval(() => { if (!w.matches(':hover')) go(i + 1); }, (+w.dataset.speed || 4) * 1000);
    });
  }

  /* ---------- predictive search ---------- */
  const searchModal = $('#searchModal');
  function openSearch() { searchModal?.classList.add('open'); setTimeout(() => $('#searchInput')?.focus(), 50); }
  function closeSearch() { searchModal?.classList.remove('open'); const r = $('[data-predictive-results]'); if (r) r.hidden = true; }
  function initPredictive() {
    const form = $('[data-predictive-form]'); if (!form) return;
    const input = $('input[name="q"]', form), out = $('[data-predictive-results]', form);
    let timer, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) { out.hidden = true; return; }
      timer = setTimeout(async () => {
        ctrl?.abort(); ctrl = new AbortController();
        out.hidden = false; out.innerHTML = '<p class="predictive-search__loading">Searching…</p>';
        try {
          const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
          const html = await (await fetch(url, { signal: ctrl.signal })).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('[data-predictive-content]');
          out.innerHTML = content ? content.outerHTML : '';
          out.hidden = !content;
        } catch (err) { if (err.name !== 'AbortError') out.hidden = true; }
      }, 250);
    });
  }

  /* ---------- sliders ---------- */
  function initSliders(root = document) {
    $$('[data-slider]', root).forEach(w => {
      if (w._init) return; w._init = true;
      const ul = $('.slider', w), btns = $$('.slider-btn', w), cur = $('.cur', w), tot = $('.tot', w), bar = $('.slider-buttons', w);
      if (!ul || btns.length < 2) return;
      const step = () => (ul.children[0]?.getBoundingClientRect().width || 0) + parseFloat(getComputedStyle(ul).columnGap || 0);
      const update = () => {
        const s = step(); if (!s) return;
        const visible = Math.round(ul.clientWidth / s), total = ul.children.length;
        cur.textContent = Math.min(total, Math.round(ul.scrollLeft / s) + 1);
        tot.textContent = total;
        btns[0].disabled = ul.scrollLeft < 5;
        btns[1].disabled = ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 5;
        bar.classList.toggle('hidden', total <= visible);
      };
      btns.forEach(b => b.addEventListener('click', () => ul.scrollBy({ left: step() * (+b.dataset.step) })));
      ul.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      addEventListener('resize', update);
      update();
    });
  }

  /* ---------- slideshow ---------- */
  function initSlideshows(root = document) {
    $$('[data-slideshow]', root).forEach(s => {
      if (s._init) return; s._init = true;
      const track = $('[data-track]', s), n = track.children.length; if (n < 2) return;
      const dots = $$('[data-dot]', s), pb = $('[data-play]', s);
      let i = 0, playing = s.dataset.autoplay === 'true' && !reduceMotion;
      const go = k => { i = (k + n) % n; track.style.transform = `translateX(-${i * 100}%)`; dots.forEach((d, j) => d.classList.toggle('active', j === i)); };
      $('[data-prev]', s)?.addEventListener('click', () => go(i - 1));
      $('[data-next]', s)?.addEventListener('click', () => go(i + 1));
      dots.forEach(d => d.addEventListener('click', () => go(+d.dataset.dot)));
      const pauseIcon = pb?.innerHTML;
      const playIcon = '<svg viewBox="0 0 12 14" fill="currentColor"><path d="M0 0l12 7-12 7z"/></svg>';
      const setPlay = v => { playing = v; if (pb) { pb.innerHTML = v ? pauseIcon : playIcon; pb.setAttribute('aria-label', v ? 'Pause slideshow' : 'Play slideshow'); } };
      pb?.addEventListener('click', () => setPlay(!playing)); setPlay(playing);
      setInterval(() => { if (playing && !s.matches(':hover') && !document.hidden) go(i + 1); }, +s.dataset.speed || 5000);
      let sx = 0;
      track.addEventListener('touchstart', e => sx = e.touches[0].clientX, { passive: true });
      track.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); });
      if (window.Shopify && Shopify.designMode) document.addEventListener('shopify:block:select', e => { const idx = [...track.children].indexOf(e.target); if (idx > -1) { setPlay(false); go(idx); } });
    });
  }

  /* ---------- counters ---------- */
  function initCounters(root = document) {
    $$('[data-counter]', root).forEach(el => {
      if (el._init) return; el._init = true;
      const end = +el.dataset.counter || 0;
      if (reduceMotion || !('IntersectionObserver' in window)) { el.textContent = end.toLocaleString('en-US'); return; }
      el.textContent = '0';
      const io = new IntersectionObserver(([en]) => {
        if (!en.isIntersecting) return; io.disconnect();
        const t0 = performance.now();
        const tick = t => { const k = Math.min(1, (t - t0) / 1600); el.textContent = Math.round(end * k).toLocaleString('en-US'); if (k < 1) requestAnimationFrame(tick); };
        requestAnimationFrame(tick);
      });
      io.observe(el);
    });
  }

  /* ---------- reels ---------- */
  function initReels(root = document) {
    $$('[data-reels]', root).forEach(w => {
      if (w._init) return; w._init = true;
      const tr = $('[data-reel-track]', w);
      $('[data-reel-prev]', w)?.addEventListener('click', () => tr.scrollBy({ left: -tr.clientWidth * .8 }));
      $('[data-reel-next]', w)?.addEventListener('click', () => tr.scrollBy({ left: tr.clientWidth * .8 }));
      $$('.reel', w).forEach(r => {
        const v = $('video', r);
        if (v) { r.addEventListener('mouseenter', () => v.play().catch(() => {})); r.addEventListener('mouseleave', () => v.pause()); }
        r.addEventListener('click', () => {
          const tpl = document.getElementById('reel-' + r.dataset.reel); const body = $('#videoModalBody');
          if (!tpl || !body) return;
          body.innerHTML = ''; body.appendChild(tpl.content.cloneNode(true));
          openModal($('#videoModal'));
          $('video', body)?.play().catch(() => {});
        });
      });
    });
  }

  /* ---------- compare ---------- */
  function initCompare(root = document) {
    $$('[data-compare]', root).forEach(c => {
      const r = $('input[type=range]', c);
      r?.addEventListener('input', () => c.style.setProperty('--pos', r.value + '%'));
    });
  }

  /* ---------- product page ---------- */
  function initProduct(root = document) {
    $$('[data-product-section]', root).forEach(sec => {
      if (sec._init) return; sec._init = true;
      let variants = [];
      try { variants = JSON.parse($('[data-variants-json]', sec).textContent); } catch (e) {}
      const sticky = $('[data-sticky-atc]');
      const mediaMain = $('[data-media-main]', sec);

      const showMedia = id => {
        if (!id) return;
        const target = $(`[data-media-id="${id}"]`, mediaMain); if (!target) return;
        $$('[data-media-id]', mediaMain).forEach(m => m.hidden = m !== target);
        $$('[data-thumb]', sec).forEach(b => b.classList.toggle('active', b.dataset.thumb == id));
      };
      $$('[data-thumb]', sec).forEach(b => b.addEventListener('click', () => showMedia(b.dataset.thumb)));

      const openLightbox = () => {
        const visible = $$('[data-media-id]', mediaMain).find(m => !m.hidden);
        const img = visible && $('img', visible); if (!img) return;
        const src = (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2000');
        $('#lightboxBody').innerHTML = `<img src="${src}" alt="${esc(img.alt)}">`;
        openModal($('#lightbox'));
      };
      $('[data-open-lightbox]', sec)?.addEventListener('click', openLightbox);
      $$('[data-media-id] img', sec).forEach(i => i.addEventListener('click', openLightbox));

      const qty = $('input[name="quantity"]', sec);
      qty?.addEventListener('change', () => { qty.value = Math.max(1, Math.min(99, parseInt(qty.value) || 1)); });

      const setVariant = v => {
        if (!v) return;
        $$('[data-variant-id]', sec).forEach(i => i.value = v.id);
        $$('[data-variant-title]', sec).forEach(e => e.textContent = v.title);
        const priceEls = [...$$('[data-price]', sec), ...(sticky ? $$('[data-price]', sticky) : [])];
        priceEls.forEach(p => {
          $('[data-price-current]', p).textContent = formatMoney(v.price);
          const cmp = $('[data-price-compare]', p);
          if (cmp) { if (v.compare_at_price > v.price) { cmp.textContent = formatMoney(v.compare_at_price); cmp.hidden = false; } else cmp.hidden = true; }
          const badge = $('[data-price-badge]', p);
          if (badge) { badge.hidden = !(!v.available || v.compare_at_price > v.price); badge.textContent = v.available ? 'Sale' : 'Sold out'; badge.classList.toggle('badge--sold', !v.available); }
        });
        $$('[data-sold-badge]', sec).forEach(b => b.hidden = v.available);
        $$('[data-sale-badge]', sec).forEach(b => b.hidden = !(v.available && v.compare_at_price > v.price));
        $$('[data-add-button]').forEach(b => { b.disabled = !v.available; b.textContent = v.available ? 'Add to cart' : 'Sold out'; });
        const wa = $('[data-wa-order]', sec);
        if (wa) {
          const title = wa.dataset.waTitle + (variants.length > 1 ? ' - ' + v.title : '');
          const text = `Hi, I want to order: ${title} (${formatMoney(v.price).replace(/<[^>]*>/g, '')}) ${location.origin}${sec.dataset.productUrl}?variant=${v.id}`;
          wa.href = `https://wa.me/${wa.dataset.waNumber}?text=${encodeURIComponent(text)}`;
        }
        if (v.featured_media) showMedia(v.featured_media.id);
        if (variants.length > 1) history.replaceState({}, '', `${sec.dataset.productUrl}?variant=${v.id}`);
      };
      $$('[data-variant-radio]', sec).forEach(r => r.addEventListener('change', () => setVariant(variants.find(v => v.id == r.value))));

      $('[data-share]', sec)?.addEventListener('click', e => {
        const b = e.currentTarget, url = location.href;
        if (navigator.share) navigator.share({ title: b.dataset.title, url }).catch(() => {});
        else navigator.clipboard?.writeText(url).then(() => toast('Link copied to clipboard'));
      });

      const vw = $('[data-viewers]', sec);
      if (vw) {
        const min = +vw.dataset.min || 5, max = Math.max(min + 1, +vw.dataset.max || 20), c = $('[data-viewers-count]', vw);
        c.textContent = min + Math.floor(Math.random() * (max - min));
        setInterval(() => { c.textContent = Math.max(min, Math.min(max, +c.textContent + Math.round(Math.random() * 4 - 2))); }, 4000);
      }

      const buy = $('[data-buy-buttons]', sec);
      if (sticky && buy && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(buy);
      }
    });
  }

  /* ---------- recommendations ---------- */
  function initRecommendations(root = document) {
    $$('[data-recommendations]', root).forEach(async el => {
      if (el._init || el.children.length) return; el._init = true;
      try {
        const html = await (await fetch(el.dataset.url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initSliders(el); }
      } catch (e) {}
    });
  }

  /* ---------- cart page ---------- */
  function initCartPage() {
    const form = $('[data-cart-form]'); if (!form) return;
    let t;
    $$('[data-cart-qty]', form).forEach(i => i.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => { const b = $('[name="update"]', form); if (b && form.requestSubmit) form.requestSubmit(b); else form.submit(); }, 400); }));
  }

  /* ---------- collection filters ---------- */
  function initFacets() {
    const form = $('[data-facet-form]');
    if (form) {
      let t;
      const submit = () => { clearTimeout(t); t = setTimeout(() => form.submit(), 350); };
      form.addEventListener('change', e => { if (e.target.matches('input[type=checkbox]')) submit(); });
      $$('input[type=number]', form).forEach(i => { i.addEventListener('change', submit); i.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); form.submit(); } }); });
    }
    $$('[data-sort-select]').forEach(s => s.addEventListener('change', () => {
      const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
    }));
  }

  /* ---------- WhatsApp popup ---------- */
  function initWaPopup() {
    const pop = $('#waPopup'); if (!pop || !T.waPopup) return;
    let seen = false;
    try { seen = sessionStorage.getItem('ph_wa_popup') === '1'; } catch (e) {}
    if (seen || (window.Shopify && Shopify.designMode)) return;
    setTimeout(() => {
      if ($('.modal.open') || $('#menuDrawer.open')) return;
      openModal(pop);
      try { sessionStorage.setItem('ph_wa_popup', '1'); } catch (e) {}
    }, T.waPopup);
  }

  /* ---------- boot ---------- */
  function initAll(root = document) {
    initSliders(root); initSlideshows(root); initCounters(root); initReels(root); initCompare(root); initProduct(root); initRecommendations(root);
  }
  initDesktopMenu(); initAnnouncements(); initPredictive(); initCartPage(); initFacets(); initWaPopup();
  initAll();

  // Theme editor support
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();
